import React from 'react'

import { useMessage } from '../../hooks/message'
import { EXPENSE_REPORT_LIST } from '../../urls'
import { usePostRequest } from '../../hooks/request'
import ExpenseAddForm from './expense-add-form'

export default function ExpenseAdd({ onCancel, categoryList, expenseReport, brandList }) {
    const products = usePostRequest({ url: EXPENSE_REPORT_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success, error } = await products.request({ data })
        if (success) {
            expenseReport.request()
            onCancel()
            showMessage('Успешно добавлен', 'is-success')
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Добавлять</b>
            </h1>
            <ExpenseAddForm loading={products.loading} categoryList={categoryList} brandList={brandList} onCancel={onCancel} onSubmit={onSubmit} />
        </div>
    )
}
